import React, { createContext, useState } from 'react';

export const contextProvider = createContext();

function Context({ children }) {
  const [totalCount, setTotalCount] = useState("")
  return (
    <contextProvider.Provider value={{ totalCount, setTotalCount }}>
      {children}
    </contextProvider.Provider>
  );
}

export default Context;
